import {
  useFlags,
  withLDProvider,
  type ProviderConfig
} from 'launchdarkly-react-client-sdk'
import { isLocalAuthBypass } from 'lib/auth/localAuth'
export { withLDProvider, type ProviderConfig }

// New flag - add to this list
// Deleting a flag - remove from this list and look for type errors across the codebase
export type FeatureFlag =
  | 'useRevRec'
  | 'usePhasePriceMetadataEditing'
  | 'showNewTaxManagement'
  | 'useSalesforceSandboxAuth'
  | 'showAttioIntegration'
  | 'showAvalaraIntegration'
  | 'showQuoteBuilder'
  | 'useOnDemandBillingFrequency'
  | 'usePerEventBilling'
  | 'showFailedPaymentNotificationsSetting'
  | 'useChattyRevRec'
  | 'useRillet'
  | 'useRestrictedQuoteEditingForSales'
  | 'useAlternativeQuoteSeatBasedMinimumText'
  | 'useXeroLedgerAccountMappings'
  | 'showServicePeriodsAlways'
  | 'useAsyncDeferredRevenueExport'
  | 'useAutomationsDunning'
  | 'showCustomerQueriesAgent'
  | 'useXeroCodeWaterfallExport'
  | 'isRevRecAnalysisReportEnabled'
  | 'useDocxQuoteDownload'
  | 'hubspotV2IntegrationEnabled'
  | 'usePdfInvoiceAlternativeHeader'
  | 'useCreditGrantLedger'
  | 'showDueDateBehaviourSetting'
  | 'useNetsuite'
  | 'useXeroForeignTaxSplit'
  | 'useEnterpriseSso'
  | 'useSocialSignIn'
  | 'useDecoupledCreditGrantBilling'
  | 'useQuoteAmendmentDealType'
  | 'useEndExistingScheduleForRenewalQuotes'
  | 'useStackedDiscounts'
  | 'useCustomerShippingAddresses'
  | 'onLedger'
  | 'useCustomerCreditGrantsV2'
  | 'useQuotePortalAuth'
  | 'usePhaseContractReferences'

export type FeatureFlags = Record<FeatureFlag, boolean>

const localBypass = isLocalAuthBypass()

export const useFeatureFlags = (): FeatureFlags => {
  const flags = useFlags()

  // In local dev mode, default all feature flags to true
  const defaultValue = localBypass ? true : false

  // To maintain reactivity AND have defaults, we need to return a proxy that applies defaults
  return new Proxy(flags, {
    get(target, prop) {
      const flag = prop as FeatureFlag
      const value = target[flag]
      return value ?? defaultValue
    }
  }) as FeatureFlags
}
